import React from 'react';
import { PHASE_TYPE_STYLES } from '../monitoring_report/edit/phaseTypes.js';
import styles from './WorkQueue.module.scss';

// Same icon and colour as the phase in the workflow graph
function WorkQueuePhaseIcon({ phaseKind }) {
  const phaseStyle = PHASE_TYPE_STYLES[phaseKind];
  if (!phaseStyle) return null;

  return (
    <span
      className={styles.phaseIcon}
      style={{ backgroundColor: phaseStyle.color }}
      data-tooltip={I18n.t(phaseKind === 'approval' ? 'decision' : 'review')}
    >
      {phaseStyle.icon}
    </span>
  );
}

export default WorkQueuePhaseIcon;
